import { useRegion } from 'context/region';
import { IRegionItem } from 'constants/types';
import { useCountriesQuery } from 'hooks/api/countries';

export const useCurrentRegion = () => {
  const { region } = useRegion();
  const { data: countries, isFetching: isFetching } = useCountriesQuery();

  const selectedRegionById = countries?.find(
    (item: IRegionItem) => item._id === region
  );

  // const selectedRegionByCode = countries?.find(
  //   (item: IRegionItem) => item.code === region
  // );

  const currentRegion = selectedRegionById;

  return {
    isFetching,
    currentRegion,
  };
};
